'use strict';

const _=require('pulsar-utils/dist-es6/_');
const ItemPickerDirective=require('../../../../../../dist-es6/client/directives/itemPickerDirective/itemPickerDirective');
const ItemPickerDirectiveController=ItemPickerDirective.DirectiveController;let

IncidentTypePickerDirective=class IncidentTypePickerDirective extends ItemPickerDirective{
get templateUrl(){return'/templates/features/fleetInsight/components/fleetIncidents/incidentTypePickerTemplate'}
get controller(){return IncidentTypePickerDirectiveController}};let


IncidentTypePickerDirectiveController=class IncidentTypePickerDirectiveController extends ItemPickerDirectiveController{
static get $inject(){return['$scope','$timeout','displaySettingsService']}

constructor($scope,$timeout,displaySettingsService){
super($scope);

this._displaySettingsService=displaySettingsService;

this.itemFormatter=type=>type.description;
this._reevaluateSelection=()=>this._reevaluateSelectionAndUpdateDisplaySettings();

const code=this._displaySettingsService.stickySettings.get('selectedIncidentTypeCode');
const stickyItem=_.find(this.items,{code});
if(_.exists(stickyItem)){
this.selectedItem=stickyItem;
}

this._reevaluateSelection();
}

_reevaluateSelectionAndUpdateDisplaySettings(){
super._reevaluateSelection();
this._displaySettingsService.stickySettings.set('selectedIncidentTypeCode',this.selectedItem.code);
}};


module.exports=IncidentTypePickerDirective;
//# sourceMappingURL=incidentTypePickerDirective.js.map
